import { Stack, Typography } from '@mui/material';
import HighlightedText from 'src/components/HighlightedText';
import DeployableArtifactList from 'src/features/deployableArtifacts/DeployableArtifactList';
import { DetectedHash, LatestChip, RuleOptionsList } from '../../PolicyVersionParts';

const NAME_SX = { color: '#D1D5DB', fontSize: '0.68rem', wordBreak: 'break-word' };

// The version string leads with the name it went by underneath, since names can change between
// versions.
const VersionCell = ({ version, searchValue }) => (
  <Stack gap={0.25} sx={{ minWidth: 0 }}>
    <Stack direction="row" alignItems="center" gap={0.75} flexWrap="wrap">
      <Typography sx={{ fontSize: '0.75rem', fontWeight: 600 }}>
        <HighlightedText text={version.policyVersion} searchValue={searchValue} />
      </Typography>
      <LatestChip version={version} />
    </Stack>
    <Typography sx={NAME_SX}>
      <HighlightedText text={version.policyName} searchValue={searchValue} />
    </Typography>
  </Stack>
);

export const VERSION_COLUMNS = [
  {
    key: 'policyVersion',
    label: 'Version',
    width: '21%',
    wrap: true,
    render: (row, searchValue) => <VersionCell version={row} searchValue={searchValue} />,
  },
  {
    key: 'policyHash',
    label: 'Detected Hash',
    width: '29%',
    wrap: true,
    render: (row, searchValue) => <DetectedHash version={row} searchValue={searchValue} />,
  },
  {
    key: 'ruleOptions',
    label: 'Rule Options',
    width: '20%',
    wrap: true,
    render: row => <RuleOptionsList ruleOptions={row.ruleOptions} />,
  },
  {
    key: 'artifacts',
    label: 'Portal Artifacts',
    width: '14%',
    wrap: true,
    render: row => <DeployableArtifactList artifacts={row.artifacts} dense showHash={false} />,
  },
  { key: 'devicesCount', label: 'Devices', width: '6%', align: 'right' },
  { key: 'createdAt', label: 'Date Added', width: '10%' },
];
